// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"d3531e7d","213":"36cf1c63","281":"4cad64a8","319":"7c167cf4","455":"70e75618","879":"394443fd"}[chunkId] + ".chunk.js";
};